import React from 'react';
import { Sidebar as Side, Menu, SubMenu, MenuItem } from 'react-pro-sidebar';
import Icon from '../Icon/Icon';
import { Link } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import { useSelector } from 'react-redux';
import { HIDE_CREATE_CONSENT } from '../../utils/features';

const Sidebar = () => {
	const isPFM = useSelector((state) => state.auth.isPFM);
	const role = jwtDecode(
		JSON.parse(sessionStorage.getItem('login'))?.token
	)?.roles;

	return (
		<Side>
			<Menu>
				{role === 'admin' && (
					<MenuItem
						icon={
							isPFM ? (
								<Icon icon="account_balance" />
							) : (
								<Icon icon="bar_chart" />
							)
						}
						component={<Link to="/" />}
					>
						Dashboard
					</MenuItem>
				)}
				<SubMenu
					defaultOpen={role === 'admin' ? false : true}
					label="Consent Request"
					icon={<Icon icon="send" />}
				>
					{!HIDE_CREATE_CONSENT && (
						<MenuItem
							icon={<Icon icon="edit_square" />}
							component={<Link to="/create-consent-request" />}
						>
							Create Request
						</MenuItem>
					)}
					<MenuItem
						icon={<Icon icon="pageview" />}
						component={<Link to="/track-consent-request" />}
					>
						Track Requests
					</MenuItem>
					<MenuItem
						icon={<Icon icon="select_check_box" />}
						component={<Link to="/view-consent" />}
					>
						View Consents
					</MenuItem>
				</SubMenu>
				{/* <MenuItem
					icon={<Icon icon="insights" />}
					component={<Link to="/account-insights" />}
					disabled
				>
					Account Insights
				</MenuItem> */}
				{role === 'admin' && (
					<SubMenu label="Admin Functions" icon={<Icon icon="settings" />}>
						<SubMenu
							label="Consent Templates"
							icon={<Icon icon="content_copy" />}
							rootStyles={{
								'.ps-menu-icon': {
									margin: '0rem',
								},
							}}
						>
							<MenuItem
								icon={<Icon icon="edit_note" />}
								component={<Link to="/create-template" />}
							>
								Create
							</MenuItem>
							<MenuItem
								icon={<Icon icon="list" />}
								component={<Link to="/list-template" />}
							>
								List
							</MenuItem>
							<MenuItem
								icon={<Icon icon="checklist" />}
								component={<Link to="/approve-template" />}
							>
								Approve
							</MenuItem>
						</SubMenu>
						<SubMenu
							label="User Management"
							icon={<Icon icon="manage_accounts" />}
							rootStyles={{
								'.ps-menu-icon': {
									margin: '0rem',
								},
							}}
						>
							<SubMenu label="User Roles" icon={<Icon icon="shield_person" />}>
								<MenuItem
									icon={<Icon icon="person_add" />}
									component={<Link to="/create-user-role" />}
								>
									Create
								</MenuItem>
								<MenuItem
									icon={<Icon icon="patient_list" />}
									component={<Link to="/list-user-role" />}
								>
									List
								</MenuItem>
								<MenuItem
									icon={<Icon icon="how_to_reg" />}
									component={<Link to="/approve-user-role" />}
								>
									Approve
								</MenuItem>
							</SubMenu>
							<SubMenu
								label="Manage Users"
								icon={
									<Icon icon="person_search" style={{ marginRight: 'unset' }} />
								}
							>
								<MenuItem
									icon={<Icon icon="person_add" />}
									component={<Link to="/create-user" />}
								>
									Create
								</MenuItem>
								<MenuItem
									icon={<Icon icon="patient_list" />}
									component={<Link to="/list-user" />}
								>
									List
								</MenuItem>
								<MenuItem
									icon={<Icon icon="how_to_reg" />}
									component={<Link to="/approve-user" />}
								>
									Approve
								</MenuItem>
							</SubMenu>
						</SubMenu>
					</SubMenu>
				)}

				<MenuItem
					icon={<Icon icon="auto_awesome" />}
					component={<Link to="http://uat-portal.prism.finfactor.in/" />}
				>
					Classifier Demo
				</MenuItem>

			</Menu>
		</Side>
	);
};

export default Sidebar;
